// @flow

import React, { Component } from 'react';
import classnames from 'classnames';

import AppInstallBannerConfig from './config';
import {
  rootStyle,
  getStylesForPosition,
  getStylesForTransition
} from './appInstallBannerStyles';
import { Transition } from 'react-transition-group';
import {
  dismissFor,
  shouldShowBanner,
  filterCurrentPath,
  appStoreLink
} from './appInstallBannerFunctions';
import { Hidden } from 'seek-style-guide/react';
import { currentDevice } from 'src/modules/chalice-user-agent/device-detect';
import { isEqual, head, get } from 'lodash';

const ANALYTICS_DELAY = 400;

type State = AppInstallBanner$State;

type AppInstallBannerProps = AppInstallBanner$Props;

class AppInstallBanner extends Component<AppInstallBannerProps, State> {
  static defaultProps = {
    targetDevices: ['Android'], // by default only target android devices
    dismissUntilInDays: AppInstallBannerConfig.dismissButtonDisappearFor
  };

  constructor(props: AppInstallBannerProps) {
    super();
    this.getCurrentPath = filterCurrentPath(props.showOnPaths || []);
  }

  state = {
    active: false
  };

  componentWillMount = () => {
    this.shouldShowBanner(this.props);
  };

  componentWillReceiveProps = (nextProps: AppInstallBannerProps) => {
    if (!isEqual(this.props, nextProps)) {
      this.shouldShowBanner(nextProps);
    }
  };
  getCurrentPath: Function;
  getAppStoreURL: AppInstallBanner$StoreLinkFn;

  ref: Element; // Dom ref is a Element or HTMLElement
  props: AppInstallBannerProps; // Props for the Component

  createAppBannerImpression = (active: boolean) => {
    return {
      type: active ? 'impression' : 'no-impression',
      deviceType: currentDevice()
    };
  };

  hideBanner = (days: number) => {
    // set a entry in cookie to dismiss for n days defaults to 7
    dismissFor(days);

    this.setState({
      active: false // set active to false to fire up transition
    });
  };

  onDismiss = (e: MouseEvent) => {
    const {
      dismissUntilInDays = AppInstallBannerConfig.dismissButtonDisappearFor
    } = this.props;
    this.props.trackingFunctions.standardTracking('close', currentDevice());
    this.hideBanner(dismissUntilInDays);
    e.preventDefault();
    e.stopPropagation();
  };

  onBannerClick = () => {
    const {
      locale,
      pathname,
      trackConversion = () => {},
      campaignSuffix
    } = this.props;
    const appStoreURL = this.getAppStoreURL({
      locale,
      path: get(head(this.getCurrentPath(pathname)), 'id', ''),
      campaignSuffix
    });

    trackConversion();
    this.props.trackingFunctions.standardTracking('view', currentDevice());

    // Timeout to wait for analytics tracking
    setTimeout(() => {
      window.location.href = appStoreURL;
    }, ANALYTICS_DELAY);
  };

  renderTheme = ({ theme: Theme, active }: { theme: any, active: boolean }) => {
    return (
      <Theme
        active={active}
        onClick={this.onBannerClick}
        onDismiss={this.onDismiss}
      />
    );
  };

  shouldShowBanner = (props: AppInstallBannerProps) => {
    const active = shouldShowBanner(props);

    this.getAppStoreURL = appStoreLink(currentDevice());
    this.setState({ active });
    this.props.trackingFunctions.impression(
      this.createAppBannerImpression(active)
    );
  };

  render() {
    const { active } = this.state;
    const { theme, position, transition } = this.props;

    return (
      <Transition
        in={active}
        timeout={transition === 'fade' ? 250 : 300}
        appear={true}
      >
        {state => (
          <Hidden
            desktop
            component="div"
            className={classnames({
              ...rootStyle,
              ...getStylesForPosition(position),
              ...getStylesForTransition(transition, state)
            })}
          >
            {this.renderTheme({ theme, active })}
          </Hidden>
        )}
      </Transition>
    );
  }
}

export default AppInstallBanner;
